import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import apiClient from "../lib/api";
import { useAuth } from "./AuthContext";

const WCtx = createContext({});
const LOCAL_KEY = "wishlist_local_v1";

export const WishlistProvider = ({ children }) => {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetch = useCallback(async () => {
    if (!user) {
      try { setItems(JSON.parse(localStorage.getItem(LOCAL_KEY) || "[]")); } catch { setItems([]); }
      return;
    }
    setLoading(true);
    try {
      const { data } = await apiClient.get("/wishlist");
      setItems(data.items || []);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { fetch(); }, [fetch]);

  const has = (pid) => items.some((p) => p.product_id === pid);

  const toggle = async (product) => {
    if (!user) {
      let next;
      if (has(product.product_id)) next = items.filter((p) => p.product_id !== product.product_id);
      else next = [...items, product];
      setItems(next);
      localStorage.setItem(LOCAL_KEY, JSON.stringify(next));
      return;
    }
    if (has(product.product_id)) {
      await apiClient.delete(`/wishlist/${product.product_id}`);
    } else {
      await apiClient.post(`/wishlist/${product.product_id}`);
    }
    fetch();
  };

  return <WCtx.Provider value={{ items, has, toggle, loading, refresh: fetch }}>{children}</WCtx.Provider>;
};

export const useWishlist = () => useContext(WCtx);
